import React from "react";

const benefitsData = [
  {
    title: "Highest Quality Guaranteed",
    text: "We will give you the highest quality possible.",
    delay: 100,
  },
  {
    title: "Experienced Team",
    text: "Increditors offers 2+ years of top-quality photobooth experience, ensuring memorable moments at your events.",
    delay: 200,
  },
  {
    title: "100% Customer Rating",
    text: "More than 1000 resolved inquiries and happy customer reviews.",
    delay: 300,
  },
  {
    title: "Fast & Easy Workflow",
    text: "We don’t like to waste your precious time! We will get right to the point!",
    delay: 400,
  },
];

const Benefits = () => {
  return (
    <section className="w-full flex justify-center items-center flex-wrap gap-[50px] py-[100px] px-4 sm:py-[50px] sm:gap-[20px]">
      {benefitsData.map((benefit, index) => (
        <div
          key={index}
          data-aos="zoom-in-left"
          data-aos-delay={benefit.delay}
          className="w-[460px] h-[460px] border border-[#76cfff5d] rounded-[200px_10px_200px_10px] flex flex-col justify-center gap-8 items-center px-6 pt-[35px] pb-[35px] transition-all duration-1000 hover:border-[#76cfff]
          lg:w-[400px] lg:h-[400px]
          md:w-[300px] md:h-[300px]
          sm:w-[250px] sm:h-[250px]
          xs:w-[90%] xs:max-w-[350px] xs:h-auto xs:py-[25px] xs:px-[20px]"
        >
          <h1 className="text-white font-poppins uppercase text-[30px] font-semibold text-center mb-[15px] leading-[40px]
            lg:text-[26px] lg:leading-[36px]
            md:text-[24px] md:leading-[34px]
            sm:text-[22px] sm:leading-[32px]
            xs:text-[20px] xs:leading-[30px]
          ">
            {benefit.title}
          </h1>
          <span className="h-[1px] w-[150px] bg-gradient-to-r from-white via-[#76cfff] to-white"></span>
          <p className="text-[#919191] text-[20px] text-center mt-[20px] font-poppins
            lg:text-[18px]
            md:text-[16px]
            sm:text-[14px]
            xs:text-[12px]
          ">
            {benefit.text}
          </p>
        </div>
      ))}
    </section>
  );
};

export default Benefits;
